import { PageInfoService } from '@pulse/browser-shared';
import { BuiltinEvents, PulseEvent, PulseEventMessage, TransformPipe } from '@pulse/common';

export class NavigationEventPipe implements TransformPipe<PulseEventMessage> {
    private previousPath = '';

    constructor(private pageInfo: PageInfoService) {}

    transform(message: PulseEventMessage): PulseEventMessage[] {
        let shouldFire = true;
        const event: PulseEvent = message.data;

        if (event.event_type && event.event_type === BuiltinEvents.NAVIGATION) {
            if (this.pageInfo.href() === this.previousPath) {
                shouldFire = false;
            }
            this.previousPath = this.pageInfo.href();
        }

        return shouldFire ? [message] : [];
    }
}
